import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { StyledCard } from './style'
import { Row, Col, Input, Button, message } from 'antd';
import imgLogo from '../../static/images/imgLogo.png';
import ApiService from '../../actions/apiService'

class PortFolioManager extends Component {
  
  state = {
    email: ''
  }
  
  onSubmit = async () => {
    const {email} = this.state;
    if (!email) {
      return message.error('please enter your email');
    }
    const response = await ApiService.sendEmail(email);
    if (response) {
      message.success('Email sent successfully!')
    }
  }
  
  onChange = (e) => {
    this.setState({
      email: e.target.value
    })
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledCard bordered={false}>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
              <center>
                <img src={imgLogo} alt="logo" />
                <p className="text">I wanted to personally welcome all Trade Portfolio Manager customers to our new home!</p>
                <p className="text">Doug Robertson and I have created a new service that combines tools, trades and education. Doug's profile and experience is listed here and pretty much speaks for itself. https://www.optionsedu.com/dougs-profile/</p>
                <p className="text">Since you are a member of Trade Portfolio Manager please enter your email address below and you will be converted over to our new OptionsEDU Tools Membership. To find out more about OptionsEDU here[link to www.optionsedu.com].</p>
                <p className="text">We also wanted to mention that you don't have to worry because your pricing as a TPM customer will always stay the same and you will get full access to the Portfolio Tools from OptionsEDU.</p>
                <p className="text">You will receive an email from OptionsEDU and you will have to set up a password here too. You will be able to continue using the old site https://www.tradeportfoliomanager.com if you want even after the conversion. At some point in time in the distant future when all of the features and changes are in OptionsEDU we will shut down access from there.</p>
                <p className="text">If you have any feedback or suggestions please let us know and we will be happy to help.</p>
                <p className="text">Thank you very much for continuing us with our adventure at OptionsEDU!</p>
                <p className="text">Jeff Donhauser</p>
              </center>
            </Col>
          </Row>
          <Row gutter={16} style={{marginTop: 50}}>
            <Col sm={12} xs={24} offset={6}>
              <Col sm={20}>
                <Input placeHolder="enter your email address" value={this.state.email} onChange={this.onChange} /></Col>
              <Col sm={4}>
                <Button type="primary" onClick={this.onSubmit}>Submit</Button>
              </Col>
            </Col>
          </Row>
        </StyledCard>
      </StyledContent>
    )
  }
}

export default PortFolioManager



// WEBPACK FOOTER //
// ./src/components/PortFolioManager/index.js